export default __webpack_public_path__ + "static/media/download-close-active.cea5c2f0.svg";